import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import ZipCodeQuoteItem from 'components/form/AddressSelector/Items/ZipCodeQuote/component';

const enhance = compose(withTranslation('StopAddress'));

export default enhance(ZipCodeQuoteItem);
